import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "./TextContainer.styled";
export var TextContainer = function (props) {
    var spacing = props.spacing, children = props.children;
    return _jsx(S.Wrap, { spacing: spacing, children: children });
};
